export var MapType;
(function (MapType) {
    MapType["TYPE_DEFAULT"] = "DEFAULT";
    MapType["TYPE_FLEET_STYLE"] = "FLEET_STYLE";
    MapType["TYPE_SATELLITE"] = "SATELLITE";
    MapType["TYPE_TERRAIN"] = "TERRAIN";
    MapType["TYPE_NIGHT"] = "NIGHT";
})(MapType || (MapType = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["ASCENDING"] = "asc";
    SortDirection["DESCENDING"] = "desc";
})(SortDirection || (SortDirection = {}));
export var TableViewTogglesValues;
(function (TableViewTogglesValues) {
    TableViewTogglesValues["VIEW_TYPE_SINGLE_CARD"] = "SINGLE_CARD";
    TableViewTogglesValues["VIEW_TYPE_MULTI_CARDS"] = "MULTI_CARDS";
    TableViewTogglesValues["VIEW_TYPE_TABLE"] = "TABLE";
})(TableViewTogglesValues || (TableViewTogglesValues = {}));
